import FileDrop from '@/components/base/FileDrop';
import type { RegisterData } from '@/pages/auth/register/types';

interface StepDocumentsProps {
  data: RegisterData;
  update: (key: keyof RegisterData, value: string) => void;
}

export default function StepDocuments({ data, update }: StepDocumentsProps) {
  return (
    <div className="space-y-6">
      <div className="flex items-start gap-3 rounded-card border border-secondary-200 bg-secondary-50 px-4 py-3">
        <i className="ri-shield-check-line mt-0.5 text-lg text-secondary-600" aria-hidden="true"></i>
        <p className="text-[13px] leading-relaxed text-secondary-800">
          المستندات تُستخدم للتحقق من هوية المغسلة فقط، وتُحفظ بشكل آمن ولا تُشارَك مع أي طرف آخر.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <FileDrop
          label="السجل التجاري"
          required
          fileName={data.commercialRegName}
          onSelect={(fileName) => update('commercialRegName', fileName)}
        />
        <FileDrop
          label="الهوية الوطنية / الإقامة"
          required
          fileName={data.idDocName}
          onSelect={(fileName) => update('idDocName', fileName)}
        />
      </div>

      <FileDrop
        label="مستندات إضافية (اختياري)"
        hint="أي مستندات إضافية تطلبها الإدارة — PNG أو JPG أو PDF"
        fileName={data.extraDocName}
        onSelect={(fileName) => update('extraDocName', fileName)}
      />
    </div>
  );
}